import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_REELS_VILLA_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelBTSCoverage } from "@website/accommodation-ui/hotel-bts-coverage";
import { HotelCalendar } from "@website/accommodation-ui/hotel-calendar";
import { HotelReserveBookingCard } from "@website/accommodation-ui/hotel-reserve-booking-card";
import { HotelReserveDetails } from "@website/accommodation-ui/hotel-reserve-details";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { VillaReserveCancellationPolicy } from "@website/accommodation-ui/villa-reserve-cancellation-policies";
import { VillaShare } from "@website/accommodation-ui/villa-share";
import { VillaSpaces } from "@website/accommodation-ui/villa-spaces";
import { VillaSpecifications } from "@website/accommodation-ui/villa-specifications";
import { VillaSimilarRoomsInform } from "@website/accommodation-ui/villa_similar-rooms_inform/villa_similar_rooms_inform";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { FabMenu } from "@website/ui/fab-menu";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { ReserveCommentsLayout } from "@website/widget/reserve-comments-layout";
import { ReserveFacilities } from "@website/widget/reserve-facilities";
import { ReserveGallery } from "@website/widget/reserve-gallery";
import { ReserveHostPolicies } from "@website/widget/reserve-host-policies";
import { ReserveMap } from "@website/widget/reserve-map";
import { ReserveNearBy } from "@website/widget/reserve-nearby";
import { ReservePolicies } from "@website/widget/reserve-policies";
import { ReserveRate } from "@website/widget/reserve-rate";
import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { FC } from "react";
import Custom404 from "../../[...gone].page";
import { useHotelPageDataTransform } from "./index.hook";
import { HotelPagePropertiesType } from "./index.types";
//
const RoomPageContent: FC<HotelPagePropertiesType> = properties => {
  const $ = _c(120);
  const router = useRouter();
  const {
    booking,
    hotelBreadcrumbsProps,
    hotelReserveFacilitiesProps,
    hotelReserveMapProps,
    gallery,
    hotelReserveDetailsProps,
    hotelReserveCancellationPoliciesProps,
    hotelReserveRateProps,
    hotelReserveCommentsProps,
    description,
    hotelReservePoliciesProps,
    hotelReserveHostPoliciesProps,
    calendarProps,
    hotelReserveBtsCoveragesProps,
    villaSpecifications,
    villaSimilarRoomsProps,
    hotelReserveNearByProps,
    villaSpaces,
    isAnyPolicyExist
  } = useHotelPageDataTransform(properties);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: "\u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      selector: "#hotel_gallery"
    };
    t1 = {
      title: "\u0645\u0634\u062E\u0635\u0627\u062A",
      selector: "#hotel_specifications"
    };
    t2 = {
      title: "\u0627\u0645\u06A9\u0627\u0646\u0627\u062A",
      selector: "#hotel_facilities"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== villaSpaces) {
    t3 = villaSpaces.length > 0 && villaSpaces?.every(_temp) ? [{
      title: "\u0641\u0636\u0627\u0647\u0627\u06CC \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      selector: "#hotel_spaces"
    }] : [];
    $[3] = villaSpaces;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "\u062A\u0642\u0648\u06CC\u0645",
      selector: "#hotel_calendar"
    };
    t5 = {
      title: "\u0642\u0648\u0627\u0646\u06CC\u0646",
      selector: "#hotel_policies"
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hotelReserveCommentsProps?.comments?.length || $[8] !== hotelReserveCommentsProps?.rate?.rate) {
    t6 = hotelReserveCommentsProps?.rate?.rate || hotelReserveCommentsProps?.comments?.length > 0 ? [{
      title: "\u0627\u0645\u062A\u06CC\u0627\u0632 \u0648 \u0646\u0638\u0631\u0627\u062A",
      selector: "#hotel_comments"
    }] : [];
    $[7] = hotelReserveCommentsProps?.comments?.length;
    $[8] = hotelReserveCommentsProps?.rate?.rate;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== hotelReserveMapProps) {
    t7 = hotelReserveMapProps && hotelReserveMapProps?.circle?.lat !== 35.696814 && hotelReserveMapProps?.circle?.lng !== 51.3498186 ? [{
      title: "\u0645\u0648\u0642\u0639\u06CC\u062A",
      selector: "#hotel_location"
    }] : [];
    $[10] = hotelReserveMapProps;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t7) {
    t8 = [t0, t1, t2, ...t3, t4, t5, ...t6, ...t7];
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const fabItems = t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = getOrigin();
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const shareUrl = `${t9}${process.env.NEXT_PUBLIC_BASE_PATHNAME}/room/${properties.roomInfo.id}`;
  const t10 = gallery[0]?.media;
  let t11;
  if ($[17] !== hotelReserveDetailsProps.address || $[18] !== hotelReserveDetailsProps.hotelTitle || $[19] !== properties.roomInfo.id || $[20] !== shareUrl || $[21] !== t10) {
    t11 = {
      address: hotelReserveDetailsProps.address,
      image: t10,
      shareUrl,
      title: hotelReserveDetailsProps.hotelTitle,
      villaId: properties.roomInfo.id
    };
    $[17] = hotelReserveDetailsProps.address;
    $[18] = hotelReserveDetailsProps.hotelTitle;
    $[19] = properties.roomInfo.id;
    $[20] = shareUrl;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const shareProperties = t11;
  const t12 = `${hotelReserveDetailsProps.hotelTitle} | اسنپ تریپ`;
  let t13;
  if ($[23] !== t12) {
    t13 = <title>{t12}</title>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== properties.roomInfo.seo?.noIndex) {
    t14 = properties.roomInfo?.seo?.noIndex && <meta content="noindex,nofollow" name="robots" />;
    $[25] = properties.roomInfo.seo?.noIndex;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getOrigin();
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = `${t15}${process.env.NEXT_PUBLIC_BASE_PATHNAME}/room/${router.query?.roomId}`;
  let t17;
  if ($[28] !== t16) {
    t17 = <link rel="canonical" href={t16} />;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t13 || $[31] !== t14 || $[32] !== t17) {
    t18 = <Head>{t13}{t14}{t17}</Head>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Header title={"\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = addEventToTracking?.bind(null, USER_TRACKING_EVENTS.VILLA_SPACES_SECTION_VIEWED, {
      product: "villa"
    });
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== fabItems) {
    t21 = <FabMenu items={fabItems} eventToTracking={t20} />;
    $[36] = fabItems;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== hotelBreadcrumbsProps) {
    t22 = <Breadcrumb {...hotelBreadcrumbsProps} className="hidden lg:flex" />;
    $[38] = hotelBreadcrumbsProps;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== shareProperties) {
    t23 = <VillaShare {...shareProperties} />;
    $[40] = shareProperties;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t22 || $[43] !== t23) {
    t24 = <div className="hidden items-center justify-between py-[22px] md:flex">{t22}{t23}</div>;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== shareProperties) {
    t25 = <div className="md:hidden"><VillaShare {...shareProperties} /></div>;
    $[45] = shareProperties;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== gallery) {
    t26 = <ReserveGallery gallery={gallery} title={"\u06AF\u0627\u0644\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} />;
    $[47] = gallery;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t25 || $[50] !== t26) {
    t27 = <div className="relative">{t25}{t26}</div>;
    $[49] = t25;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== router.query?.roomId) {
    t28 = isChannel(["jek", "android"]) && <HotelShortVideos className="px-6 lg:m-0 lg:hidden" displayType="REELS" displayId={ZIN_DISPLAY_KEY_REELS_VILLA_PAGE} zinKey={ZIN_KEY} zinTags={`${router.query?.roomId}`} />;
    $[52] = router.query?.roomId;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t24 || $[55] !== t27 || $[56] !== t28) {
    t29 = <div className="px-0 md:px-[24px] xl:px-[calc((100%-1200px)/2)]">{t24}{t27}{t28}</div>;
    $[54] = t24;
    $[55] = t27;
    $[56] = t28;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== hotelReserveDetailsProps) {
    t30 = <HotelReserveDetails {...hotelReserveDetailsProps} />;
    $[58] = hotelReserveDetailsProps;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== villaSpecifications) {
    t31 = <VillaSpecifications villaSpecifications={villaSpecifications} />;
    $[60] = villaSpecifications;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== hotelReserveFacilitiesProps) {
    t32 = <ReserveFacilities {...hotelReserveFacilitiesProps} />;
    $[62] = hotelReserveFacilitiesProps;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== villaSimilarRoomsProps) {
    t33 = <VillaSimilarRoomsInform {...villaSimilarRoomsProps} />;
    $[64] = villaSimilarRoomsProps;
    $[65] = t33;
  } else {
    t33 = $[65];
  }
  let t34;
  if ($[66] !== hotelReserveBtsCoveragesProps) {
    t34 = <HotelBTSCoverage btsCoverage={hotelReserveBtsCoveragesProps} />;
    $[66] = hotelReserveBtsCoveragesProps;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== villaSpaces) {
    t35 = <VillaSpaces spaces={villaSpaces} />;
    $[68] = villaSpaces;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== description) {
    t36 = description && <div><h6 className="text-on-surface-high-emphasis text-headline-6 mb-5">اقامتگاه</h6><CollapsibleText ariaLabel="description" collapsedClassName="h-[50px]" content={<p className="whitespace-pre-wrap">{description}</p>} /></div>;
    $[70] = description;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== calendarProps) {
    t37 = <HotelCalendar {...calendarProps} showTitle={true} />;
    $[72] = calendarProps;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== hotelReservePoliciesProps) {
    t38 = <ReservePolicies {...hotelReservePoliciesProps} />;
    $[74] = hotelReservePoliciesProps;
    $[75] = t38;
  } else {
    t38 = $[75];
  }
  let t39;
  if ($[76] !== hotelReserveHostPoliciesProps) {
    t39 = <ReserveHostPolicies {...hotelReserveHostPoliciesProps} />;
    $[76] = hotelReserveHostPoliciesProps;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] !== hotelReserveCancellationPoliciesProps || $[79] !== isAnyPolicyExist) {
    t40 = isAnyPolicyExist ? <VillaReserveCancellationPolicy {...hotelReserveCancellationPoliciesProps} /> : null;
    $[78] = hotelReserveCancellationPoliciesProps;
    $[79] = isAnyPolicyExist;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== hotelReserveRateProps) {
    t41 = <ReserveRate {...hotelReserveRateProps} />;
    $[81] = hotelReserveRateProps;
    $[82] = t41;
  } else {
    t41 = $[82];
  }
  let t42;
  if ($[83] !== hotelReserveCommentsProps) {
    t42 = <ReserveCommentsLayout {...hotelReserveCommentsProps} />;
    $[83] = hotelReserveCommentsProps;
    $[84] = t42;
  } else {
    t42 = $[84];
  }
  let t43;
  if ($[85] !== t30 || $[86] !== t31 || $[87] !== t32 || $[88] !== t33 || $[89] !== t34 || $[90] !== t35 || $[91] !== t36 || $[92] !== t37 || $[93] !== t38 || $[94] !== t39 || $[95] !== t40 || $[96] !== t41 || $[97] !== t42) {
    t43 = <div className="col-span-2"><div className="flex flex-col gap-[56px]">{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}</div></div>;
    $[85] = t30;
    $[86] = t31;
    $[87] = t32;
    $[88] = t33;
    $[89] = t34;
    $[90] = t35;
    $[91] = t36;
    $[92] = t37;
    $[93] = t38;
    $[94] = t39;
    $[95] = t40;
    $[96] = t41;
    $[97] = t42;
    $[98] = t43;
  } else {
    t43 = $[98];
  }
  let t44;
  if ($[99] !== booking) {
    t44 = <div className="top-14 z-[5] col-span-1 mt-6 h-fit lg:sticky"><HotelReserveBookingCard {...booking} /></div>;
    $[99] = booking;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== t43 || $[102] !== t44) {
    t45 = <div className="relative grid-cols-3 gap-6 lg:grid">{t43}{t44}</div>;
    $[101] = t43;
    $[102] = t44;
    $[103] = t45;
  } else {
    t45 = $[103];
  }
  let t46;
  if ($[104] !== hotelReserveMapProps) {
    t46 = hotelReserveMapProps && <ReserveMap {...hotelReserveMapProps} />;
    $[104] = hotelReserveMapProps;
    $[105] = t46;
  } else {
    t46 = $[105];
  }
  let t47;
  if ($[106] !== hotelReserveNearByProps) {
    t47 = hotelReserveNearByProps && <ReserveNearBy {...hotelReserveNearByProps} />;
    $[106] = hotelReserveNearByProps;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] !== t45 || $[109] !== t46 || $[110] !== t47) {
    t48 = <div className="px-[24px] pb-[90px] xl:px-[calc((100%-1200px)/2)]">{t45}{t46}{t47}</div>;
    $[108] = t45;
    $[109] = t46;
    $[110] = t47;
    $[111] = t48;
  } else {
    t48 = $[111];
  }
  let t49;
  if ($[112] !== t29 || $[113] !== t48) {
    t49 = <section><article className="relative flex flex-col">{t29}{t48}</article></section>;
    $[112] = t29;
    $[113] = t48;
    $[114] = t49;
  } else {
    t49 = $[114];
  }
  let t50;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Footer />;
    $[115] = t50;
  } else {
    t50 = $[115];
  }
  let t51;
  if ($[116] !== t18 || $[117] !== t21 || $[118] !== t49) {
    t51 = <>{t18}{t19}{t21}{t49}{t50}</>;
    $[116] = t18;
    $[117] = t21;
    $[118] = t49;
    $[119] = t51;
  } else {
    t51 = $[119];
  }
  return t51;
};
const Index: NextPage<HotelPagePropertiesType> = properties => {
  const $ = _c(3);
  if (!properties.roomInfo) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <RoomPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";
function _temp(item) {
  return item?.amenitiesGroup?.length > 0;
}